<template>
  <div class="detail-wrap">
    <b-container class="pt-4">
      <b-row class="pb-3">
        <b-col md="5">
          <div class="content-left">
            <span class="top-icon"></span>
            <b-card class="nft-item mb-3" no-body>
              <b-card-img
                class="nft-image"
                :class="{ pixelated: isPixelated }"
                v-if="!loadingData"
                v-bind:src="
                  utils.nftIpfsLink(nftData.image) ||
                  `data:image/svg+xml;charset=UTF-8,%3Csvg width='200' height='200' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200' preserveAspectRatio='none'%3E%3Cdefs%3E%3Cstyle type='text/css'%3E%23holder_17cb7089c7d text %7B fill:'%23DFE1E6';font-weight:bold;font-family:Poppins, monospace;font-size:50pt %7D %3C/style%3E%3C/defs%3E%3Cg id='holder_17cb7089c7d'%3E%3Crect width='200' height='200' fill='%23EBECF0'%3E%3C/rect%3E%3Cg%3E%3Ctext x='44.421875' y='118.5' fill='%23DFE1E6'%3E%23${tokenId}%3C/text%3E%3C/g%3E%3C/g%3E%3C/svg%3E`
                "
                alt="image"
              ></b-card-img>
              <b-skeleton-img height="400px" v-else></b-skeleton-img>
              <b-card-body
                v-if="nftData.attributes && !loadingData"
                class="list-attr is-flex space-between"
              >
                <b-card
                  class="mb-3 attr-item"
                  no-body
                  v-for="(it, key) in nftData.attributes"
                  :key="key"
                >
                  <div>
                    <b-card-text class="type">{{
                      it.trait_type.toUpperCase()
                    }}</b-card-text>
                    <b-card-text class="name" :style="'color: ' + it.color"
                      ><b-link
                        :href="`/marketplace/?flt=${encodeURIComponent(
                          JSON.stringify({
                            [it.trait_type]: { [it.value]: true },
                          })
                        )}`"
                        >{{ it.value }}</b-link
                      ></b-card-text
                    >
                  </div>
                  <div v-if="it.rarity">
                    <b-card-text class="rarity"
                      >{{ (it.rarity || 0).toFixed(2) }}% have this
                      trait</b-card-text
                    >
                  </div>
                </b-card>
              </b-card-body>
              <b-card-body
                v-if="loadingData"
                class="list-attr pl-3 pb-3 pr-3 is-flex space-between"
              >
                <b-card
                  class="mt-3 attr-item"
                  no-body
                  v-for="(i, key) in [1, 2, 3, 4]"
                  :key="key"
                >
                  <div>
                    <b-skeleton animation="fade" width="100%"></b-skeleton>
                    <b-skeleton animation="fade" width="100%"></b-skeleton>
                  </div>
                  <div>
                    <b-skeleton animation="fade" width="100%"></b-skeleton>
                  </div>
                </b-card>
              </b-card-body>
            </b-card>
          </div>
        </b-col>
        <b-col class="content-right" md="7">
          <router-view
            v-if="$route.name !== 'Detail'"
            :nftData="nftData"
          ></router-view>
          <b-card v-else no-body class="nft-info mb-0">
            <div>
              <b-card-body class="p-0">
                <div class="is-flex space-between align-items">
                  <div>
                    <b-card-text v-if="ftSymbol || nftName" class="mb-1 nft-acc"
                      ><b-link @click="$router.go(-1)"
                        ><b-icon icon="chevron-double-left"></b-icon>
                        {{ ftSymbol }} - {{ nftName }}</b-link
                      ></b-card-text
                    >
                    <b-skeleton
                      v-else
                      animation="fade"
                      width="50px"
                    ></b-skeleton>
                    <b-card-title
                      v-if="nftData.name || tokenId"
                      class="nft-name mb-3"
                      >{{ nftData.name || `# ${tokenId}` }}</b-card-title
                    >
                    <b-skeleton
                      v-else
                      animation="fade"
                      width="100px"
                      heihgt="36px"
                    ></b-skeleton>
                  </div>
                  <div>
                    <b-card-text v-if="isPublished">
                      <b-card-text class="price-info" v-if="isPublished">
                        Price:
                        <span class="value">{{
                          utils.bigToCommon(price, ftDecimals)
                        }}</span>
                        <span class="token-symbol">{{ ftSymbol }}</span>
                      </b-card-text>
                    </b-card-text>
                    <div
                      v-if="!isPublished && bestPrice && !bestPrice.eq(0)"
                      class="price-info"
                    >
                      <p class="text-style mb-1">Top Bid</p>
                      <span>
                        <span class="value">{{
                          utils.bigToCommon(bestPrice, ftDecimals)
                        }}</span>
                        <span class="token-symbol">{{ ftSymbol }}</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="line"></div>
                <div class="is-flex space-between pb-3 pt-3 align-items">
                  <div class="nft-address-info">
                    <b-card-text class="nft-address">
                      <b-card-text class="is-flex mb-2">
                        <span class="equal">Owned by:</span>
                        <sid-link v-if="chainId && owner" :addr="owner" />
                        <!-- <b-link v-if="chainId && owner" :href="utils.addressLink(chainId, owner)" target="_blank">{{ utils.truncate(owner, 20) }}</b-link> -->
                        <b-skeleton
                          v-else
                          animation="fade"
                          width="160px"
                          heihgt="36px"
                        ></b-skeleton>
                      </b-card-text>
                      <b-card-text class="is-flex">
                        <span class="equal">Contract:</span>
                        <sid-link v-if="chainId && nft" :addr="nft" />
                        <!-- <b-link v-if="chainId && nft" :href="utils.addressLink(chainId, nft)" target="_blank">{{ utils.truncate(nft, 20) }}</b-link> -->
                        <b-skeleton
                          v-else
                          animation="fade"
                          width="160px"
                          heihgt="36px"
                        ></b-skeleton>
                      </b-card-text>
                    </b-card-text>
                  </div>
                  <div class="button-list">
                    <div v-if="!loadingData">
                      <b-button
                        @click="$bvModal.show('bid-nft')"
                        :disabled="isBidded"
                        v-if="owner !== address"
                        class="btn-custom btn-market-order"
                        >Make Offer</b-button
                      >

                      <b-btn
                        v-if="owner !== address && isPublished"
                        @click="$bvModal.show('buy-nft')"
                        class="btn-custom btn-buy-now ml-3"
                      >
                        Buy Now
                      </b-btn>
                      <div v-if="owner === address">
                        <b-button
                          v-if="!isPublished"
                          class="btn-custom btn-ask-sell"
                          @click="$bvModal.show('ask-nft')"
                        >
                          Ask to sell
                        </b-button>
                      </div>
                    </div>
                    <b-skeleton v-else type="button"></b-skeleton>
                  </div>
                </div>
              </b-card-body>
            </div>
          </b-card>
          <div v-if="isPublished && owner === address" class="your-stake mb-4">
            <b-card no-body>
              <div class="head">
                <b-card-text class="mb-0"> Your Order</b-card-text>
              </div>
              <b-row class="p-3">
                <b-col>
                  <b-card-text class="mb-0 label">Price</b-card-text>
                  <b-card-text>{{
                    utils.bigToCommon(price, ftDecimals)
                  }}</b-card-text>
                </b-col>
                <b-col>
                  <b-card-text class="mb-0 label">Share</b-card-text>
                  <b-card-text>{{
                    utils.bigToCommon(askShare, 18)
                  }}</b-card-text>
                </b-col>
                <b-col>
                  <b-button
                    v-if="isPublished"
                    @click="$bvModal.show('update-ask-nft')"
                    class="btn-custom btn-update card-link"
                    >Update</b-button
                  >
                  <b-button
                    v-if="isPublished"
                    @click="removeAsk()"
                    class="btn-remove"
                  >
                    Remove
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </div>
          <div class="your-offer mb-4" v-if="isBidded">
            <b-card no-body>
              <div class="head">
                <b-card-text class="mb-0"> Your Offer </b-card-text>
              </div>
              <b-row class="p-3">
                <b-col>
                  <b-card-text class="mb-0 text-price"
                    >Price/Stake ({{ ftSymbol }})</b-card-text
                  >
                  <b-card-text class="t-balance">{{
                    utils.bigToCommon(bidStake, ftDecimals)
                  }}</b-card-text>
                </b-col>
                <b-col>
                  <b-card-text class="mb-0 text-reward"
                    >Reward ({{ ftSymbol }})</b-card-text
                  >
                  <b-card-text class="t-balance">{{
                    utils.bigToCommon(bidReward, ftDecimals)
                  }}</b-card-text>
                </b-col>
                <b-col>
                  <b-button
                    @click="$bvModal.show('update-bid-nft')"
                    class="btn-custom card-link btn-update"
                    >Update</b-button
                  >
                  <b-button @click="removeBid()" class="btn-custom btn-remove"
                    >Remove</b-button
                  >
                </b-col>
              </b-row>
            </b-card>
          </div>
          <div class="best-offer mb-3">
            <b-card no-body v-if="!loadingMarket">
              <div
                class="head is-flex space-between"
                v-if="bidSize && bidSize > 0"
              >
                <b-card-text class="mb-0"> Best Offer</b-card-text>
                <b-card-text class="total-offer"
                  >Total
                  {{ utils.bigToCommon(bidSize.add(sizeOfListMarket), 0, 0) }}
                  offers</b-card-text
                >
              </div>

              <b-row
                class="p-3"
                v-if="bestPrice.gte(bestBidMarketPrice) && bestPrice.gt(0)"
              >
                <b-col>
                  <b-card-text class="mb-0 text-address">Address</b-card-text>
                  <sid-link v-if="chainId && bestBidder" :addr="bestBidder" />
                  <!-- <b-link target="_blank" :href="utils.addressLink(chainId, bestBidder)">{{ utils.truncate(bestBidder, 20) }}</b-link> -->
                </b-col>
                <b-col>
                  <b-card-text class="mb-0 text-price"
                    >Price ({{ ftSymbol }})</b-card-text
                  >
                  <b-card-text class="t-balance">{{
                    utils.bigToCommon(bestPrice, ftDecimals)
                  }}</b-card-text>
                </b-col>
                <div v-if="owner === address">
                  <div>
                    <b-button
                      @click="$bvModal.show('sell-nft')"
                      class="btn-custom btn-sell mr-2"
                      :disabled="isPublished && owner === address"
                      >Sell
                      <b-icon
                        v-if="isPublished && owner === address"
                        icon="info-circle-fill"
                        v-b-tooltip.hover.top="
                          `You have to remove your order before selling the item`
                        "
                      ></b-icon
                    ></b-button>
                  </div>
                </div>
              </b-row>
              <b-row class="p-3" v-if="bestBidMarketPrice.gt(bestPrice)">
                <b-col>
                  <b-card-text class="mb-0 text-address">Address</b-card-text>
                  <sid-link
                    v-if="chainId && bestBidMarketOwner"
                    :addr="bestBidMarketOwner"
                  />
                  <!-- <b-link target="_blank" :href="utils.addressLink(chainId, bestBidMarketOwner)">{{ utils.truncate(bestBidMarketOwner, 20) }}</b-link> -->
                </b-col>
                <b-col>
                  <b-card-text class="mb-0 text-price"
                    >Price ({{ ftSymbol }})</b-card-text
                  >
                  <b-card-text class="t-balance">{{
                    utils.bigToCommon(bestBidMarketPrice, ftDecimals)
                  }}</b-card-text>
                </b-col>
                <div v-if="owner === address">
                  <div>
                    <b-button
                      @click="$bvModal.show('sell-market')"
                      class="btn-custom btn-sell mr-2"
                      :disabled="isPublished && owner === address"
                      >Sell
                      <b-icon
                        v-if="isPublished && owner === address"
                        icon="info-circle-fill"
                        v-b-tooltip.hover.top="
                          `You have to remove your order before selling the item`
                        "
                      ></b-icon
                    ></b-button>
                  </div>
                </div>
              </b-row>
              <div
                class="best-offer-empty"
                v-if="bidSize.add(sizeOfListMarket).eq(0)"
              >
                <b-card-img
                  :src="require('@/assets/images/nologo.svg')"
                  alt="Image"
                ></b-card-img>
                <div class="best-offer-empty-text">No Offer Yet.</div>
              </div>
            </b-card>
            <b-skeleton-table
              v-else
              :rows="1"
              :columns="3"
              :table-props="{ bordered: true, striped: true }"
            ></b-skeleton-table>
          </div>

          <!--  -->
          <div class="line"></div>
          <ProductionEfficiency :efficiency="efficiency" />
          <div class="line1"></div>
          <BattlePower :power="power" />
        </b-col>
      </b-row>
    </b-container>
    <div>
      <b-modal
        id="bid-nft"
        no-close-on-backdrop
        centered
        hide-footer
        title="Make an offer"
      >
        <Bid
          @bid-success="getMarketInfo().then(() => $bvModal.hide('bid-nft'))"
          @bid-cancel="$bvModal.hide('bid-nft')"
        />
      </b-modal>
      <b-modal
        id="update-bid-nft"
        no-close-on-backdrop
        centered
        hide-footer
        title="Update your offer"
      >
        <UpdateBid
          @update-bid-success="
            getMarketInfo().then(() => $bvModal.hide('update-bid-nft'))
          "
          @update-bid-cancel="$bvModal.hide('update-bid-nft')"
        />
      </b-modal>
      <b-modal
        id="ask-nft"
        no-close-on-backdrop
        centered
        hide-footer
        title="Ask to sell your NFT"
      >
        <Ask
          @ask-success="getMarketInfo().then(() => $bvModal.hide('ask-nft'))"
          @ask-cancel="$bvModal.hide('ask-nft')"
        />
      </b-modal>
      <b-modal
        id="update-ask-nft"
        no-close-on-backdrop
        centered
        hide-footer
        title="Update your NFT price"
      >
        <UpdateAsk
          @update-ask-success="
            getMarketInfo().then(() => $bvModal.hide('update-ask-nft'))
          "
          @update-ask-cancel="$bvModal.hide('update-ask-nft')"
        />
      </b-modal>
      <b-modal
        id="buy-nft"
        no-close-on-backdrop
        centered
        hide-footer
        title="Buy NFT"
      >
        <Buy
          @buy-success="getMarketInfo().then(() => $bvModal.hide('buy-nft'))"
          @buy-cancel="$bvModal.hide('buy-nft')"
        />
      </b-modal>
      <b-modal
        id="sell-nft"
        no-close-on-backdrop
        centered
        hide-footer
        title="Sell NFT"
      >
        <Sell
          :bidder="bestBidder"
          :price="bestPrice"
          @sell-success="getMarketInfo().then(() => $bvModal.hide('sell-nft'))"
          @sell-cancel="$bvModal.hide('sell-nft')"
        />
      </b-modal>
      <b-modal
        id="sell-market"
        no-close-on-backdrop
        centered
        hide-footer
        title="Sell NFT"
      >
        <SellMarket
          :bidder="bestBidMarketOwner"
          :price="bestBidMarketPrice"
          @sell-success="
            getMarketInfo().then(() => $bvModal.hide('sell-market'))
          "
          @sell-cancel="$bvModal.hide('sell-market')"
        />
      </b-modal>
    </div>
    <b-toast
      id="tx-confirm"
      toast-class="b-info"
      title="Transaction Process"
      solid
      no-auto-hide
    >
      Your transaction is being processed.
    </b-toast>
    <b-toast
      id="tx-success"
      toast-class="b-success"
      title="Transaction Success"
      solid
      auto-hide-delay="8000"
    >
      Your transaction is successful.
    </b-toast>
    <b-toast
      id="tx-error"
      toast-class="b-danger"
      title="Transaction Failed"
      solid
      auto-hide-delay="8000"
    >
      Your transaction was not successfully broadcasted.
    </b-toast>
    <b-toast
      id="not-found"
      toast-class="b-warning"
      title="Not Found"
      solid
      auto-hide-delay="8000"
    >
      This NFT is NOT minted yet.
    </b-toast>
  </div>
</template>
<script>
import { ethers } from "ethers";
import axios from "axios";
import utils from "@/utils";
import { Market, Multicall } from "@bazarion/sdk";
import Bid from "./Bid.vue";
import Ask from "./Ask.vue";
import Buy from "./Buy.vue";
import Sell from "./Sell.vue";
import SellMarket from "./SellMarket.vue";
import UpdateBid from "./UpdateBid.vue";
import UpdateAsk from "./UpdateAsk.vue";
import urljoin from "url-join";
import config from "@/config";
import { CoreGame } from "@/amakunicom/sdk";

export default {
  name: "Detail",
  components: {
    Bid,
    UpdateBid,
    Ask,
    UpdateAsk,
    Buy,
    Sell,
    SellMarket,
  },
  data: () => ({
    power: null,
    efficiency: null,
    showBid: false,
    isBidded: false,
    address: "",
    bestBidder: "",
    bestPrice: ethers.BigNumber.from(0),
    bestBidMarketOwner: "",
    bestBidMarketPrice: ethers.BigNumber.from(0),
    tokenId: 0,
    owner: "",
    price: "0",
    bidStake: "0",
    askShare: ethers.BigNumber.from(0),
    bazaMPTotalSupply: ethers.BigNumber.from(0),
    bidReward: "0",
    bidSize: 0,
    isPublished: false,
    ft: "",
    nft: "",
    marketAddress: "",
    ftSymbol: "",
    nftSymbol: "",
    nftName: "",
    ftDecimals: "",
    nftData: {},
    isNative: false,
    ftLink: "",
    market: {},
    loadingData: true,
    loadingMarket: true,
    isPixelated: false,
  }),
  updated: async function () {
    this.$nextTick().then(() => {
      setTimeout(() => {
        let nftImg = document.querySelector(".nft-image");
        if (nftImg) {
          if (nftImg.naturalWidth < 200) {
            this.isPixelated = true;
          } else {
            this.isPixelated = false;
          }
        }
      }, 5000);
    });
  },
  created: async function () {
    this.tokenId = this.$route.params.id;
    this.nft = this.$route.params.nft;
    let tokens = this.getCoreConfig();
    let { ft, nft, chainId, kuniItem } = tokens;
    this.nftSaru = nft;
    this.chainId = chainId;
    if (!this.nft) {
      this.nft = nft;
    }

    this.provider = await this.getProvider(Number(chainId));
    this.market = await Market.setMarket(ft, this.nft, this.provider);

    this.marketAddress = this.market.market;
    this.ft = ethers.utils.getAddress(this.market.ft);
    this.nft = ethers.utils.getAddress(this.market.nft);
    this.isNative = this.market.isNative;
    this.address = this.market.address;

    this.game = await CoreGame.initWith(tokens, this.provider);

    this.game
      .productionEfficiencyAndPower(this.tokenId, kuniItem === this.nft)
      .then(({ eff, power, name }) => {
        if (name) {
          this.nftData = { name: power.name };
        }
        this.power = power;
        this.efficiency = eff;
      })
      .catch((err) => {
        console.log(err);
      });

    // if (this.nft === nft)
    //   this.scholarship
    //     .getPowerBy(this.tokenId)
    //     .then((power) => (this.power = power));

    // if (this.nft === kuniItem) {
    //   this.scholarship.getMeta(this.tokenId).then((power) => {
    //     this.power = power;
    //     this.nftData = { name: power.name };
    //   });
    // }
    // if (this.nft === this.nftSaru)
    //   this.scholarship
    //     .getProductionEfficiency(this.tokenId)
    //     .then((eff) => (this.efficiency = eff));

    try {
      let uri = await this.market.tokenURI(this.tokenId);
      if (uri) {
        let { data } = await axios.get(this.utils.nftIpfsLink(uri));
        data.attributes = (data.attributes || []).filter((el) => {
          return (
            el.trait_type !== "id" &&
            el.value.trim() &&
            el.trait_type !== "name" &&
            el.trait_type !== "image"
          );
        });
        this.nftData = data;
      }
    } catch (e) {
      console.log(e);
    }

    try {
      let item = await axios.get(
        urljoin(
          config.apiBaseUrl,
          `/api/${this.chainId}/data/${this.nft}/get/${this.tokenId}`
        )
      );
      if (Object.keys(this.nftData).length === 0) {
        this.nftData.attributes = Object.keys(item.data.item)
          .filter((k) => {
            return k !== "id" && k !== "name" && k !== "image";
          })
          .map((type) => {
            return {
              trait_type: type,
              value: item.data.item[type],
            };
          });
        this.nftData.name = item.data.item.name;
        this.nftData.image = item.data.item.image;
      }
      this.nftData.attributes = this.nftData.attributes.map((attr) => {
        attr.rarity =
          (item.data.data[attr.value] * 100) / item.data.totalSupply;
        attr.color = this.checkRarity(attr.rarity);
        return attr;
      });
    } catch (e) {
      // console.log(e)
    }

    this.loadingData = false;

    try {
      await this.getMarketInfo();
      this.loadingMarket = false;
    } catch (e) {
      this.$bvToast.show("not-found");
    }
  },
  methods: {
    async getBidInfo() {
      if (!this.bazaMPTotalSupply.eq(0)) {
        let totalStakedBaza = await this.market.ftBalanceOf(this.marketAddress);
        let bidShare = await this.market.getBidShare(
          this.tokenId,
          this.address
        );
        let bidStake = await this.market.getBidPrice(
          this.tokenId,
          this.address
        );
        let total = bidShare.mul(totalStakedBaza).div(this.bazaMPTotalSupply);
        this.bidReward = total.sub(bidStake);
        this.bidStake = bidStake;

        this.isBidded = !bidShare.eq(0);
      } else {
        this.isBidded = false;
        this.bidStake = ethers.BigNumber.from(0);
      }
    },
    async getNftInfo() {
      let calls = await Multicall.setMulticall(
        this.ft,
        this.nft,
        this.provider
      );
      let { owner, askPrice, bidSize, bestBid, askShare } =
        await calls.getNftInfo(this.tokenId);
      this.owner = owner;
      this.price = askPrice;
      this.bidSize = bidSize;
      this.bestBidder = bestBid[0];
      this.bestPrice = bestBid[1];
      this.askShare = askShare;

      await this.getBidInfo();

      this.isPublished = this.price.gt(0);
      if (this.isPublished) {
        this.owner = await this.market.getOwnerByTokenId(this.tokenId);
      }
    },
    async getMarketInfo() {
      let calls = await Multicall.setMulticall(
        this.ft,
        this.nft,
        this.provider
      );
      let {
        totalSupply,
        exchangeFee,
        withdrawFee,
        treasuryFee,
        stakeRate,
        tvl,
        ftDecimals,
        ftSymbol,
        nftSymbol,
        nftName,
        marketTotalSupply,
        bestBidMarketOwner,
        bestBidMarketPrice,
        sizeOfListMarket,
      } = await calls.getMarketInfo();
      this.totalSupply = totalSupply;
      this.exchangeFee = exchangeFee;
      this.withdrawFee = withdrawFee;
      this.treasuryFee = treasuryFee;
      this.stakeRate = stakeRate;
      this.tvl = tvl;
      this.ftDecimals = ftDecimals;
      this.ftSymbol = ftSymbol;
      this.nftName = nftName;
      this.nftSymbol = nftSymbol;
      this.bazaMPTotalSupply = marketTotalSupply;
      this.bestBidMarketOwner = bestBidMarketOwner;
      this.bestBidMarketPrice = bestBidMarketPrice;
      this.sizeOfListMarket = sizeOfListMarket;
      if (!this.totalSupply.eq(0) && !marketTotalSupply.eq(0)) {
        this.roi = utils.calROI(this.tvl, marketTotalSupply);
      }

      await this.getNftInfo();
    },
    async removeBid() {
      let tx = await this.market.removeBid(this.tokenId);
      this.$bvToast.show("tx-confirm");
      await tx.wait();
      this.$bvToast.show("tx-success");
      this.$bvToast.hide("tx-confirm");
      await this.getMarketInfo();
    },
    async removeAsk() {
      let tx = await this.market.removeAsk(this.tokenId);
      this.$bvToast.show("tx-confirm");
      await tx.wait();
      this.$bvToast.show("tx-success");
      this.$bvToast.hide("tx-confirm");
      await this.getMarketInfo();
    },
    checkRarity: function (rarity) {
      if (0 < rarity && rarity < 1.2) {
        return "#ff8000";
      } else if (1.19 < rarity && rarity < 2.4) {
        return "#a335ee";
      } else if (2.39 < rarity && rarity < 5.4) {
        return "#0770dd";
      } else if (5.39 < rarity && rarity < 12.3) {
        return "#1eff00";
      } else {
        return "#fff";
      }
    },
  },
};
</script>
<style lang="scss">
.detail-wrap {
  .space-between {
    justify-content: space-between;
  }
  .list-attr {
    padding: 0 20px 5px 20px;
  }
  .content-left {
    position: relative;
    .top-icon {
      height: 1%;
      width: 30%;
      transform: skew(52deg);
      display: block;
      background-color: #eb345f;
      position: absolute;
      left: 40%;
      top: 0px;
    }
    &:before {
      position: absolute;
      content: "";
      width: 100%;
      height: 100%;
      top: 0;
      z-index: 0;
      left: 0;
      display: block;
      background: #fff;
      clip-path: polygon(
        0 0,
        calc(36% + 3px) 0,
        calc(40% + 1px) calc(2% - 2px),
        calc(96% + 1px) calc(2% - 2px),
        100% calc(5% - 4px),
        100% calc(97% + 3px),
        calc(96% + 3px) 100%,
        0% 100%
      );
    }
    .nft-item {
      clip-path: polygon(
        0 0,
        36% 0,
        40% 2%,
        96% 2%,
        100% 5%,
        100% 97%,
        96% 100%,
        0% 100%
      );
      // clip-path: polygon(0 0, 36% 0, 41% 3%, 96% 3%, 100% 6%, 100% 97%, 96% 100%, 0% 100%);
      background: transparent;
      border: 2px solid #fff;
      background-image: linear-gradient(180deg, #180d48, rgba(70, 50, 100, 0)),
        linear-gradient(0deg, #482e65, #482e65);
      img,
      .b-aspect-content {
        margin-top: 15px;
        padding: 20px;
      }
    }
    .attr-item {
      padding: 10px;
      border-radius: 8px;
      text-align: center;
      width: calc(50% - 7px);
      background: transparent;
      border-color: #5a4f6b;
      .type {
        margin-bottom: 0;
        font-size: 13px;
        color: #a798bf;
        text-transform: uppercase;
        font-weight: 600;
      }
      .name {
        font-weight: 600;
        color: #fff;
        text-transform: uppercase;
        a {
          color: inherit;
          text-decoration: none;
          &:hover {
            color: #eb345f;
          }
        }
      }
      .rarity {
        font-size: 14px;
        color: #a798bf;
        font-weight: 600;
      }
    }
  }
  .content-right {
    .nft-info {
      border: none;
      background-color: transparent;
      .equal {
        min-width: 95px;
        font-weight: 600;
      }
      .nft-address-info {
        margin-right: 20px;
      }
      .nft-address {
        a {
          color: #eb345f;
          font-weight: 600;
        }
      }
      .button-list {
        @media (max-width: 532px) {
          padding-top: 20px;
          padding-bottom: 15px;
        }
      }
      .price-info {
        font-weight: normal;
        align-items: flex-end;
        text-align: right;
        .text-style {
          text-transform: uppercase;
          font-weight: 600;
          color: #a798bf;
          font-size: 20px;
        }
        .value,
        .token-symbol {
          font-weight: 500;
          font-size: 48px;
          font-family: "Bebas Neue", cursive;
          color: #eb345f;
        }
        .token-symbol {
          margin-left: 5px;
        }
      }
      .card-link {
        display: inline-block;
      }
      .btn-market-order {
        background-color: rgba(25, 110, 194, 0.1);
        &:hover {
          background-color: rgba(25, 110, 194, 0.295);
        }
      }
      .btn-buy-now,
      .btn-update,
      .btn-ask-sell {
        color: #fff;
        background-color: #9d22c1;
        &:hover {
          background-color: #891daa;
        }
      }
    }
    .nft-acc {
      font-size: 20px;
      font-weight: 700;
      text-transform: uppercase;
      a {
        color: #eb345f;
      }
    }
    .head {
      font-weight: 600;
      padding: 8px 16px;
      background-color: #433060;
    }
    .nft-name {
      font-weight: 700;
      font-size: 48px;
      color: #fff;
    }
    .your-stake {
      .label {
        color: #5e6c84;
        font-weight: 400;
        font-size: 14px;
      }
    }
    .your-offer,
    .your-stake {
      > .card {
        border-radius: 8px;
        overflow: hidden;
        background: transparent;
        border-color: #523261;
      }
      .text-reward,
      .text-price {
        color: #fff;
        font-weight: 600;
      }
      .card-link {
        padding: 0.375rem 0.75rem;
        margin-right: 10px;
        background-color: #9d22c1;
        color: #fff;
        margin-top: 5px;
        font-size: 12px;
        border-radius: 8px;
        border: none;
        font-weight: 700;
        &:hover {
          background-color: #891daa;
        }
      }
      .btn-remove {
        border: none;
        font-size: 12px;
        margin-top: 5px;
        border-radius: 8px;
        font-weight: 700;
        background-image: linear-gradient(to top, #503161, rgba(70, 50, 100, 0)),
          linear-gradient(to bottom, #503161, #503161);
        border-bottom: none !important;
        &:focus {
          box-shadow: none;
        }
      }
    }
    .best-offer {
      > .card {
        border-radius: 8px;
        overflow: hidden;
        background-color: transparent;
        border-color: #523261;
        a {
          color: #eb345f;
          font-weight: 600;
        }
      }
      .text-address,
      .text-price {
        color: #fff;
        font-weight: 600;
      }
      .btn-sell {
        background-color: #e53b11;
        border: none;
        margin-left: 10px;
        border-radius: 8px;
        font-size: 12px;
        min-width: 80px;
        font-weight: 700;
        &:focus {
          box-shadow: none;
        }
        &:hover {
          background-color: #cc350f;
        }
      }
    }
    .best-offer-empty {
      img {
        width: 48px;
        margin: 20px auto 5px auto;
        display: block;
      }
      .best-offer-empty-text {
        width: 100px;
        margin: 10px auto 20px auto;
        display: block;
        color: #5e6c84;
      }
    }
  }
}
#ask-nft {
  .btn-cancel,
  .btn-update,
  .btn-approve,
  .btn-ask-to-sell {
    &:before {
      border-top-color: #312346;
    }
  }
  .btn-cancel {
    background: #4c386a !important;
    border-bottom: none;
  }
}

#bid-nft {
  .btn-cancel {
    background: #4c386a;
    border-bottom: none !important;
  }
  .btn-cancel,
  .btn-bid {
    &::before {
      border-top-color: #33254a;
    }
  }
}
</style>
